import { Fragment, useEffect, useRef, useState } from "react";
import { RouteComponentProps } from "../../models/RouteComponent";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";

import { Grid } from "@mui/material";
import { FormControl, FormLabel } from "@mui/joy";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import { InputTextarea } from "primereact/inputtextarea";
import DropdownApi from "../../components/DropdownApi";

import S3DocumentsUpload from "../../components/S3DocumentsUpload";

import ImageS3Upload from "../../components/ImageS3Upload";

import { Calendar } from "primereact/calendar";

import { updateVehicle } from "../../service/vehicleService";
import IntervalDropdown from "../../components/IntervalDropdown";
import RiskAssessmentComponent from "../../components/RiskAssessmentComponent";
import VehicleChecklistTable from "./vehicle-checklist-table";
import VehicleSiteTable from "./vehicle-Site-table";

export default function VehicleView(props: RouteComponentProps) {
  const vehicle = props.vehicle || {};

  const [name, setName] = useState(vehicle.name || "");
  const [description, setDescription] = useState(vehicle.description || "");
  const [vehicleType, setVehicleType] = useState(vehicle.vehicle_type || "");
  const [vehicleTypeObject, setVehicleTypeObject] = useState<any>({});
  const [vinNumber, setVinNumber] = useState(vehicle.vin_number || "");
  const [licenseNumber, setLicenseNumber] = useState(vehicle.license_number || "");
  const [price, setPrice] = useState(vehicle.price || "");
  const [purchasedDate, setPurchasedDate] = useState(
    vehicle.purchased_date ? new Date(vehicle.purchased_date) : undefined
  );
  const [maintenanceValue, setMaintenanceValue] = useState(vehicle?.maintenance_value || "");
  const [maintenanceInterval, setMaintenanceInterval] = useState(
    vehicle?.maintenance_interval || ""
  );
  const [expectedLifeValue, setExpectedLifeValue] = useState(vehicle?.expected_life_value || "");
  const [expectedLifeInterval, setExpectedLifeInterval] = useState(
    vehicle?.expected_life_interval || ""
  );
  const [maintenanceDate, setMaintenanceDate] = useState(
    vehicle.maintenance_start_date ? new Date(vehicle.maintenance_start_date) : undefined
  );

  const [nextMaintenanceWindowDate, setNextMaintenanceWindowDate] = useState(
    vehicle.next_maintenance_window ? new Date(vehicle.next_maintenance_window) : undefined
  );
  const [expectedLifeWindow, setExpectedLifeWindow] = useState(
    vehicle.expected_life_window ? new Date(vehicle.expected_life_window) : undefined
  );

  const [photo, setPhoto] = useState("");
  const [loading, setLoading] = useState(vehicle.name || false);
  const toast = useRef(null as any);

  const session = props?.session || {};

  const clientId = session.client_id;
  const s3Key = vehicle?.s3_key || `vehicle/${vehicle.id}`;

  useEffect(() => {
    setMaintenanceValue(vehicleTypeObject?.maintenance_value);
    setMaintenanceInterval(vehicleTypeObject?.maintenance_interval);
    setExpectedLifeValue(vehicleTypeObject?.expected_life_value);
    setExpectedLifeInterval(vehicleTypeObject?.expected_life_interval);
  }, [vehicleType]);

  async function vehicleUpdate() {
    const updateObject: any = {
      name,
      description,
      vehicle_type: vehicleType,
      vin_number: vinNumber,
      license_number: licenseNumber,
      purchased_date: purchasedDate,
      maintenance_interval: maintenanceInterval,
      maintenance_value: maintenanceValue,
      expected_life_value: expectedLifeValue,
      expected_life_interval: expectedLifeInterval,
      maintenance_start_date: maintenanceDate,
      next_maintenance_window: nextMaintenanceWindowDate,
      expected_life_window: expectedLifeWindow,
      s3_key: s3Key,
    };
    if (price && price != "") {
      updateObject.price = price;
    }
    updateVehicle(updateObject, vehicle.id).then((r: any) => {
      const updatedVehicle = r;
      if (!!updatedVehicle.next_maintenance_window) {
        setNextMaintenanceWindowDate(new Date(updatedVehicle.next_maintenance_window));
      }
      if (!!updatedVehicle.expected_life_window) {
        setExpectedLifeWindow(new Date(updatedVehicle.expected_life_window));
      }
      toast.current.show({
        severity: "success",
        summary: "Vehicle Updated Successfully",
        life: 3000,
      });
    });
  }

  const record_id = vehicle.id || "";

  return (
    <Fragment>
      <TabView>
        <TabPanel header="Vehicle Details">
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <FormControl>
                  <ImageS3Upload photo={photo} setPhoto={setPhoto} s3Key={s3Key} toast={toast} />
                </FormControl>
              </Grid>
              <Grid item xs={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormControl sx={{ flexGrow: 1 }}>
                      <FormLabel>
                        Name<div style={{ color: "red" }}>*</div>
                      </FormLabel>
                      <FormControl
                        sx={{
                          display: { sm: "flex-column", md: "flex-row" },
                          gap: 2,
                        }}
                      >
                        <InputText
                          value={name}
                          onChange={e => setName(e.target.value)}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                        />
                      </FormControl>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl>
                      <FormLabel>Vin Number</FormLabel>
                      <InputText
                        value={vinNumber}
                        onChange={e => setVinNumber(e.target.value)}
                        type="text"
                        className="p-inputtext-sm PrimeSmallInput"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl>
                      <FormLabel>License Number</FormLabel>
                      <InputText
                        value={licenseNumber}
                        onChange={e => setLicenseNumber(e.target.value)}
                        type="text"
                        className="p-inputtext-sm PrimeSmallInput"
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item xs={12}>
                <FormControl>
                  <FormLabel>Description</FormLabel>
                  <FormControl
                    sx={{
                      display: { sm: "flex-column", md: "flex-row" },
                      gap: 2,
                    }}
                  >
                    <InputTextarea
                      value={description}
                      placeholder="Description"
                      onChange={e => setDescription(e.target.value)}
                    />
                  </FormControl>
                </FormControl>
              </Grid>
              <br />
              <Grid item xs={6}>
                <DropdownApi
                  apiPath="vehicle-type"
                  optionLabel="name"
                  optionValue="id"
                  label="Vehicle Type"
                  selectedData={vehicleType}
                  setSelectedData={setVehicleType}
                  setSelectedObject={setVehicleTypeObject}
                />
              </Grid>
              <br />
              <Grid item xs={6}>
                <FormControl sx={{ flexGrow: 1 }}>
                  <FormLabel>Price</FormLabel>
                  <InputText
                    value={price}
                    onChange={e => setPrice(e.target.value)}
                    type="number"
                    className="p-inputtext-sm PrimeSmallInput"
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Card>
        </TabPanel>
        <TabPanel header="Maintenance">
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Purchased Date</FormLabel>
                  <Calendar
                    dateFormat="yy-mm-dd"
                    value={purchasedDate}
                    onChange={e => setPurchasedDate(e.value || new Date())}
                    showIcon
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <IntervalDropdown
                  label="Expected Life"
                  selectedInterval={expectedLifeInterval || vehicle?.expected_life_interval || ""}
                  setSelectedInterval={setExpectedLifeInterval}
                  selectedValue={expectedLifeValue || vehicle?.expected_life_value || ""}
                  setSelectedValue={setExpectedLifeValue}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Last Maintenance Date</FormLabel>
                  <Calendar
                    dateFormat="yy-mm-dd"
                    value={maintenanceDate}
                    onChange={e => setMaintenanceDate(e.value || new Date())}
                    showIcon
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <IntervalDropdown
                  label="Maintenance"
                  selectedInterval={maintenanceInterval || vehicle?.maintenance_interval || ""}
                  setSelectedInterval={setMaintenanceInterval}
                  selectedValue={maintenanceValue || vehicle?.maintenance_value || ""}
                  setSelectedValue={setMaintenanceValue}
                />
              </Grid>
              {vehicle?.maintenance_start_date && (
                <Grid item xs={6}>
                  <FormControl>
                    <FormLabel>Next Maintenance Window</FormLabel>
                    <Calendar
                      dateFormat="yy-mm-dd"
                      value={nextMaintenanceWindowDate}
                      onChange={e => setNextMaintenanceWindowDate(e.value || new Date())}
                      showIcon
                    />
                  </FormControl>
                </Grid>
              )}
              {vehicle?.expected_life_window && (
                <Grid item xs={6}>
                  <FormControl>
                    <FormLabel>Expected Replacement Date</FormLabel>
                    <Calendar
                      dateFormat="yy-mm-dd"
                      value={expectedLifeWindow}
                      onChange={e => setExpectedLifeWindow(e.value || new Date())}
                      showIcon
                    />
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </Card>
        </TabPanel>
        <TabPanel header="Sites">
          <VehicleSiteTable
            globalLoader={props.globalLoader}
            breadcrumbs={props.breadcrumbs}
            session={props.session}
            setBreadcrumbs={props.setBreadcrumbs}
            setGlobalLoader={props.setGlobalLoader}
            setSession={props.setSession}
            accessLevel={props.accessLevel}
            vehicle={vehicle}
            setAccessLevel={props.setAccessLevel}
            setEmployee={props.setEmployee}
          />
        </TabPanel>
        <TabPanel header="Checklist">
          <VehicleChecklistTable
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            client_id={clientId}
            props={props}
          />
        </TabPanel>
        <TabPanel header="Documents">
          <S3DocumentsUpload
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            client_id={clientId}
            type="vehicle"
            props={props}
          />
        </TabPanel>
        <TabPanel header="Risk">
          <RiskAssessmentComponent
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            client_id={clientId}
            type="Vehicle"
            props={props}
          />
        </TabPanel>
      </TabView>
      <Button
        type="button"
        icon="pi pi-save"
        label="Save"
        className="p-button-outlined"
        size="small"
        style={{
          position: "absolute",
          fontSize: "small",
          right: 70,
          top: 75,
          color: "#2dd36f",
        }}
        onClick={() => vehicleUpdate()}
      />

      <Toast ref={toast} />
    </Fragment>
  );
}
